import { __assign, __rest } from "tslib";
import { Checkbox, HStack, Input } from '@chakra-ui/react';
import React, { useEffect, useMemo } from 'react';
import TextComponent from '../TextComponent';
import PopoverComponent from '../PopOver';
import useCheckboxes from '../../hooks/useCheckboxes';
var MultipleOptionSelection = function (_a) {
    var defaultSelected = _a.defaultSelected, options = _a.options, placeholder = _a.placeholder, onUpdate = _a.onUpdate, selectProps = __rest(_a, ["defaultSelected", "options", "placeholder", "onUpdate"]);
    var _b = useCheckboxes(), handleCheckBoxes = _b.handleCheckBoxes, selectedCheckboxes = _b.selected;
    useEffect(function () {
        defaultSelected.forEach(function (i) {
            handleCheckBoxes({ name: i.value || '', checked: true });
        });
    }, []);
    var selected = useMemo(function () {
        return options.filter(function (i) { return !!(i.value && selectedCheckboxes.includes(i.value)); });
    }, [selectedCheckboxes]);
    var inputValue = useMemo(function () {
        var label = selected.map(function (i) { return i.label; }).join(', ');
        return selected.length ? label : placeholder || '';
    }, [selected]);
    useEffect(function () {
        onUpdate && onUpdate(selected);
    }, [selected]);
    return (React.createElement(PopoverComponent, __assign({ matchWidth: true, target: React.createElement(Input, { readOnly: true, cursor: 'pointer', borderColor: 'primary', name: 'date-picker-input', bg: 'background.default', value: inputValue }), contentProps: {
            display: 'flex',
            w: 'full',
            maxH: '300px',
            overflow: 'scroll'
        } }, selectProps), options === null || options === void 0 ? void 0 : options.map(function (_a, index) {
        var value = _a.value, label = _a.label;
        return (React.createElement(HStack, { key: index, w: 'full', px: 1.5, py: 3, overflow: 'scroll', borderBottomWidth: '1px' },
            React.createElement(Checkbox, { name: value || '', isChecked: !!(value && selectedCheckboxes.includes(value)), onChange: function (e) { return handleCheckBoxes({ name: e.target.name, checked: e.target.checked }); } }),
            React.createElement(TextComponent, null, label)));
    })));
};
export default MultipleOptionSelection;
//# sourceMappingURL=MultipleOptionSelection.js.map